import { render, staticRenderFns } from "./TheFacilitiesLockEditForm.vue?vue&type=template&id=4b5d051c&"
import script from "./TheFacilitiesLockEditForm.vue?vue&type=script&lang=js&"
export * from "./TheFacilitiesLockEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports